import ReportEditor from './reportEditor';
import entityComposition from '../common/classes/entityComposition';
import { canEditSelector } from './reportSelectors';
export default entityComposition(ReportEditor, ['report'], {
  canEdit: canEditSelector,
  user: state => state.login.user,
  version: state => {
    var _state$report;
    return (state === null || state === void 0 || (_state$report = state.report) === null || _state$report === void 0 || (_state$report = _state$report.active) === null || _state$report === void 0 || (_state$report = _state$report.content) === null || _state$report === void 0 ? void 0 : _state$report.version) || null;
  },
  reportID: state => {
    var _state$report2;
    return (state === null || state === void 0 || (_state$report2 = state.report) === null || _state$report2 === void 0 || (_state$report2 = _state$report2.active) === null || _state$report2 === void 0 || (_state$report2 = _state$report2.content) === null || _state$report2 === void 0 ? void 0 : _state$report2.id) || null;
  }
}, ['notification', 'configBehavior']);